// extracted by mini-css-extract-plugin
export default {"container":"hINFLROxSgF_JbyKFFQw","imageContainer":"yk8Pf6OtHHuowlyoKUt9","image":"DZHQi9PHQCg74PPLKlEe","text":"mCcH4_R_q2ZpsRrdaXBg"};